import { Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Plan } from 'src/app/model/Plan';
import { PlanService } from 'src/app/service/plan.service';
import { emptyValidator } from 'src/app/validator/empty-form-validator';

export enum PlansFormMode {
  ADD,
  EDIT,
  COPY,
  IMPORT
}

@Component({
    selector: 'app-plans-form',
    templateUrl: './plans-form.component.html',
    styleUrls: ['./plans-form.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PlansFormComponent implements OnInit {

  @Input() height: string = '300px';
  @Input() mode: PlansFormMode;
  @Input() plan: Plan;
  @Output() formEvent = new EventEmitter<FormGroup>();
  originalPlanName: string = '';
  planFile:any;

  FormMode = PlansFormMode;
  formGroup: FormGroup;

  choosePlanDefaultStr:string = $localize`Choose plan file...`;
  planToImportFileName:string;

  get nameCtrl() { return this.formGroup.get('nameCtrl'); }
  get descriptionCtrl() { return this.formGroup.get('descriptionCtrl'); }
  get envCtrl() { return this.formGroup.get('envCtrl'); }
  get planFileNameCtrl() { return this.formGroup.get('planFileNameCtrl');}
  get planFileSourceCtrl() { return this.formGroup.get('planFileSourceCtrl')}
  

  constructor(private planSrv: PlanService, private renderer: Renderer2,) {
    
  }

  ngOnInit(): void {
    
    this.formGroup = new FormGroup({
      nameCtrl: new FormControl('', [
        Validators.required, emptyValidator(),
        Validators.pattern("[a-zA-Z0-9\-\_\. ]*")
      ], [this.checkfPlanNameIsAlreadyTaken()]),
      descriptionCtrl: new FormControl('', [
      ]),
      envCtrl: new FormControl('', [
      ])
    });

    if(this.mode == PlansFormMode.IMPORT){
      this.formGroup.addControl('planFileNameCtrl', new FormControl('',[Validators.required]));
      this.formGroup.addControl('planFileSourceCtrl', new FormControl('',[Validators.required]));
    }

    this.formGroup.valueChanges.subscribe(val => {
      this.formEvent.emit(this.formGroup);
    });

    if(this.mode == PlansFormMode.EDIT){
      this.nameCtrl.setValue(this.plan.name);
      this.descriptionCtrl.setValue(this.plan.description);
    }else if(this.mode == PlansFormMode.COPY){
      this.nameCtrl.setValue(this.plan.name + '-copy');
      this.descriptionCtrl.setValue(this.plan.description);
    }

    this.envCtrl.setValue(this.plan.selectedEnvironmentName);

    //keep the original plan name
    if(this.plan && this.mode == PlansFormMode.EDIT){
      this.originalPlanName = this.plan.name;
    }

    setTimeout(() => this.renderer.selectRootElement('#otsc-plan-form-name').focus(), 0);
  }

  fileBrowseHandler($event): void {
    this.planToImportFileName = $event.target.files[0].name
    this.planFileSourceCtrl.patchValue({
      fileSource: $event.target.files[0]
    })
  }

  checkfPlanNameIsAlreadyTaken(): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
     return timer(500).pipe(
        switchMap(() => this.planSrv.validatePlanName(this.plan.selectedEnvironmentId, control.value.trim())),
        map((result) => {
          if(this.mode == PlansFormMode.EDIT && control.value.trim().toLowerCase() == this.originalPlanName.toLowerCase()){
            return null;
          }
          return result.body ? null: { plannameExists: true } 
          }
        ),
      );
    };
  };
}

